module.exports = __webpack_public_path__ + "static/img/img(52).81401ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(52).png
// module id = 3CfZ
// module chunks = 1